import React from "react";
import { Description } from "@mui/icons-material";
import { Box, Chip, Paper, Typography } from "@mui/material";
import ScoreBadge from "./ScoreBadge";

interface PageCardProps {
  label: string;
  path: string;
  lastUpdated?: string | null;
  score: number;
  isDynamic?: boolean;
  onClick: () => void;
}

const PageCard: React.FC<PageCardProps> = ({ label, path, lastUpdated, score, isDynamic, onClick }) => (
  <Paper
    variant="outlined"
    onClick={onClick}
    sx={{
      p: 2.5,
      borderRadius: 3,
      position: "relative",
      cursor: "pointer",
      transition: "box-shadow 0.15s ease, border-color 0.15s ease",
      "&:hover": { boxShadow: 2, borderColor: "primary.main" },
    }}
  >
    {isDynamic && (
      <Chip
        size="small"
        label="Dynamic"
        color="info"
        variant="outlined"
        sx={{ position: "absolute", top: 20, right: 20 }}
      />
    )}
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        mb: 2.5,
        pr: isDynamic ? 11 : 0,
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          bgcolor: "action.hover",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Description color="primary" />
      </Box>
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Typography fontWeight={800} noWrap>{label}</Typography>
        <Typography variant="body2" color="text.secondary" noWrap>{path}</Typography>
      </Box>
    </Box>

    <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 2 }}>
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>Last edited</Typography>
        <Typography fontWeight={700}>{lastUpdated ? new Date(lastUpdated).toLocaleDateString("en-CA") : "Not yet"}</Typography>
      </Box>
      <ScoreBadge score={score} />
    </Box>
  </Paper>
);

export default PageCard;
